import React from 'react';
import StockInPage from './StockInPage';
import StockInPageMobile from './StockInPageMobile';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const StockInPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <StockInPageMobile /> : <StockInPage />;
};

export default StockInPageWrapper; 